<script>
import { computed } from "vue";
import { CheckCircleIcon, XCircleIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/vue/20/solid'

export default {
  props: ["type", "message"],
  components: {
    CheckCircleIcon,
    XCircleIcon,
    ExclamationTriangleIcon,
    XMarkIcon
  },
  setup(props) {
    const styleType = computed(function() {
      return props.type;
    });

    return {
      styleType
    };
  },
};
</script>

<template>
  <div class="rounded-md p-4 mb-5" :class="{ 'bg-green-50': type==='success' || type==='info', 'bg-yellow-50': type==='warning', 'bg-red-50': type==='danger' }">
    <div class="flex">
      <div class="flex-shrink-0">
        <CheckCircleIcon v-if="type==='success'" class="h-5 w-5 text-green-400" aria-hidden="true" />
        <ExclamationTriangleIcon v-if="type==='warning'" class="h-5 w-5 text-yellow-400" aria-hidden="true" />
        <XCircleIcon v-if="type==='danger'" class="h-5 w-5 text-red-400" aria-hidden="true" />
      </div>
      <div class="ml-3">
        <p class="text-sm font-medium text-green-800" :class="{ 'text-green-800': type==='success' || type==='info', 'text-yellow-700': type==='warning', 'text-red-700': type==='danger' }">
          <template v-if="message">
            <span v-html="message" />
          </template>
          <template v-else>
            <slot></slot>
          </template>
        </p>
      </div>
      <!--<div class="ml-auto pl-3">
        <div class="-mx-1.5 -my-1.5">
          <button type="button" class="inline-flex rounded-md bg-green-50 p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50" aria-label="Close">
            <span class="sr-only">Dismiss</span>
            <XMarkIcon class="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
      </div>-->
    </div>
  </div>
</template>

<style></style>
